import React, { Component, Fragment } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import DefaultModal from 'Modals/DefaultModal';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import Loader from 'Pure/Loader';
import bemit from 'Functions/bemit';
import { action } from 'Shared/Routes';
import { num } from 'Shared/utilities';
const qwest = window.qwest;
export default class BookingRow extends Component {
  state = {
    loading: false,
    modal: false
  };
  modal_ref = React.createRef();
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchCompanies();
  }
  fetchCompanies = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post(action('getAllCompanies')).then(function (xhr, response) {
      component.setState({
        companies: response.data
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  openModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: true,
      modal_trigger: e?.target
    });
  };
  closeModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: false,
      modal_trigger: undefined
    });
  };
  cancel = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading) return;
    component.setState({
      loading: true
    });
    let url;
    if (props.data.packorder) {
      url = action('cancelCompanyBooking');
    } else {
      url = action('cancelBooking');
    }
    qwest.post(url, {
      id: props.data?.id
    }).then(function (xhr, response) {
      component.setState({
        loading: false
      });
      props.requestUpdate();
      component.modal_ref?.current?.click();
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      data,
      blank = false,
      fields
    } = props;
    numeral.locale('en');
    moment.locale('fr');
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-red']
    }) : undefined;
    const duration = numeral(num(data.end_hour)).subtract(num(data.start_hour)).format('0');
    const total_amount = numeral(data.packorder.pack_info.amount).multiply(num(data.number_of_people)).multiply(duration).format('0.00');
    const percentage = numeral(total_amount).multiply(0.05).format('0.00');
    const commission = numeral(total_amount).subtract(percentage).format('0.00');
    let output = /*#__PURE__*/React.createElement("div", {
      className: !data.packorder ? "c-dashboard__row" : "c-dashboard__row c-dashboard__row--company"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, moment(data.date).format('DD/MM/YYYY')), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell "
    }, data.customer.lastname, " ", data.customer.firstname), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, data.packorder.code), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, (state.companies || []).find(company => company.id === data.packorder.company_id)?.name), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, data.amount || 0), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, data.packorder.pack_info.amount), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, data.number_of_people), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, total_amount, " \u20AC"), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, commission, " \u20AC"), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-actions"
    }, data.status === 'paid' ? /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary', 'small']),
      onClick: component.openModal
    }, "Annuler") : undefined), /*#__PURE__*/React.createElement(DefaultModal, {
      open: state.modal,
      title: "Annulation de r\xE9servation",
      trigger_src: state.modal_trigger,
      "close-ref": component.modal_ref,
      "with-footer-close": false,
      "hide-controls": true,
      bemit: ['default', 'small'],
      onClose: component.closeModal
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message c-message--orange"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "Annuler cette r\xE9servation\xA0? Cette action est d\xE9finitive.")), getFormStatus(state), /*#__PURE__*/React.createElement("div", {
      className: "c-modal__controls"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn c-flat-btn--red u-margin-right-25",
      onClick: component.cancel
    }, loader, "Oui, Annuler"), /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn",
      onClick: e => component.modal_ref?.current?.click()
    }, "Fermer"))));
    return output;
  }
}
